import {
  FETCH_REMOTE_WORK_ENVIRONMENT,
  FETCH_REMOTE_WORK_ENVIRONMENT_SUCCESS,
  FETCH_REMOTE_WORK_ENVIRONMENT_FAILURE,
  SAVE_REMOTE_WORK_ENVIRONMENT,
  SAVE_REMOTE_WORK_ENVIRONMENT_SUCCESS,
  SAVE_REMOTE_WORK_ENVIRONMENT_FAILURE,
  FETCH_TALENT_REMOTE_WORK_ENVIRONMENT,
  FETCH_TALENT_REMOTE_WORK_ENVIRONMENT_SUCCESS,
  FETCH_TALENT_REMOTE_WORK_ENVIRONMENT_FAILURE
} from "../action-types";

const initialState = {
  loading: false,
  saving: false,
  data: null,
  error: null,
  talentData: null,
  talentLoading: false,
  talentError: null
};

export default function remoteWorkEnvironmentReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REMOTE_WORK_ENVIRONMENT:
      return { ...state, loading: true, error: null };
    case FETCH_REMOTE_WORK_ENVIRONMENT_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_REMOTE_WORK_ENVIRONMENT_FAILURE:
      return { ...state, loading: false, error: action.error };
    case SAVE_REMOTE_WORK_ENVIRONMENT:
      return { ...state, saving: true, error: null };
    case SAVE_REMOTE_WORK_ENVIRONMENT_SUCCESS:
      return { ...state, saving: false, data: { ...state.data, ...action.payload } };
    case SAVE_REMOTE_WORK_ENVIRONMENT_FAILURE:
      return { ...state, saving: false, error: action.error };
    case FETCH_TALENT_REMOTE_WORK_ENVIRONMENT:
      return { ...state, talentLoading: true, talentError: null };
    case FETCH_TALENT_REMOTE_WORK_ENVIRONMENT_SUCCESS:
      return { ...state, talentLoading: false, talentData: action.payload };
    case FETCH_TALENT_REMOTE_WORK_ENVIRONMENT_FAILURE:
      return { ...state, talentLoading: false, talentError: action.error };
    default:
      return state;
  }
}
